import { AsyncEvent } from 'ts-events';
class ComposeAreaSettings {
    settingsService;
    constructor(settingsService) {
        this.settingsService = settingsService;
    }
    getSubmitKey() {
        return this.parseSubmitKey(this.settingsService.retrieveUntrustedKeyValuePair('submitKey', false));
    }
    setSubmitKey(submitKey) {
        this.settingsService.storeUntrustedKeyValuePair('submitKey', this.parseSubmitKey(submitKey).toString());
    }
    parseSubmitKey(submitKey) {
        try {
            submitKey = parseInt(submitKey, 10);
        }
        catch {
        }
        switch (submitKey) {
            case 0:
            case 1:
                return submitKey;
            default:
                return 0;
        }
    }
}
class UserInterfaceSettings {
    settingsService;
    constructor(settingsService) {
        this.settingsService = settingsService;
    }
    getUserInterface() {
        const value = this.settingsService.retrieveUntrustedKeyValuePair('userInterface', false);
        switch (value) {
            case "minimal":
                return "minimal";
            default:
                return "default";
        }
    }
    setUserInterface(userInterface) {
        this.settingsService.storeUntrustedKeyValuePair('userInterface', userInterface);
        this.settingsService.userInterfaceChange.post(userInterface);
    }
}
export class SettingsService {
    settingsChangedEvent = new AsyncEvent();
    static STORAGE_KEY_PREFIX = 'settings-';
    composeArea;
    userInterface;
    log;
    storage;
    userInterfaceChange = new AsyncEvent();
    static $inject = ['$window', 'LogService'];
    constructor($window, logService) {
        this.log = logService.getLogger('Settings-S');
        this.storage = $window.localStorage;
        this.composeArea = new ComposeAreaSettings(this);
        this.userInterface = new UserInterfaceSettings(this);
    }
    storeUntrustedKeyValuePair(key, value) {
        this.log.debug('Storing settings key:', key);
        this.storage.setItem(SettingsService.STORAGE_KEY_PREFIX + key, value);
        this.settingsChangedEvent.post();
    }
    retrieveUntrustedKeyValuePair(key, alwaysCreate = true) {
        this.log.debug('Retrieving settings key:', key);
        if (this.hasUntrustedKeyValuePair(key)) {
            return this.storage.getItem(SettingsService.STORAGE_KEY_PREFIX + key);
        }
        else {
            if (alwaysCreate) {
                this.storeUntrustedKeyValuePair(key, '');
            }
            return '';
        }
    }
    removeUntrustedKeyValuePair(key) {
        this.log.debug('Removing settings key:', key);
        this.storage.removeItem(SettingsService.STORAGE_KEY_PREFIX + key);
        this.settingsChangedEvent.post();
    }
    hasUntrustedKeyValuePair(key) {
        const item = this.storage.getItem(SettingsService.STORAGE_KEY_PREFIX + key);
        return item !== null;
    }
}
